import React, {useEffect, useState, Fragment} from 'react'
import {Collapse, NavItem, NavLink, Badge} from 'reactstrap'
import classnames from 'classnames'
import {getCatalogCategories} from '../../services/ProductLinesServices'
import PropTypes from 'prop-types'

const MockupGeneratorNavTab = (props) => {
    const {selectedCategory, handleSelectCategory} = props
    const [categories, setCategories] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchCategory = async () => {
            try {
                const {data, success, message} = await getCatalogCategories()
                if (!success) throw new Error(message)
                setCategories(data)
            } catch (e) {
                setError(e.message)
            } finally {
                setLoading(false)
            }
        }
        fetchCategory()
    }, [])

    return (
        <div className="ProductCatalogNav nav-tabs mt-1 col-2">
            {loading ? (
                ''
            ) : error ? (
                <p className="text-danger fs-14 pl-3 pr-3">
                    <i>{error}</i>
                </p>
            ) : (
                <Fragment>
                    <div className="CategoryItem">
                        <NavItem>
                            <NavLink
                                className={classnames('cursor-pointer font-weight-500', {active: selectedCategory === ''})}
                                onClick={() => {
                                    handleSelectCategory('')
                                }}
                            >
                                All Products
                            </NavLink>
                        </NavItem>
                    </div>
                    {Array.isArray(categories) &&
                        categories.map((category, index) => {
                            return (
                                <RecursiveItem
                                    index={index}
                                    category={category}
                                    categoryChildren={category.children}
                                    selectedCategory={selectedCategory}
                                    handleSelectCategory={handleSelectCategory}
                                />
                            )
                        })}
                </Fragment>
            )}
        </div>
    )
}

const CategoryItem = ({selectedCategory, category, isOpen, categoryChildren, handleSelectCategory, index}) => {
    const isParent = Array.isArray(categoryChildren) && categoryChildren.some((child) => child._id === selectedCategory)

    const active = selectedCategory === category._id

    return (
        <NavItem className="w-100" key={`SidebarListProductMockup_${index}`}>
            <NavLink
                className={classnames('cursor-pointer d-flex align-items-center', {
                    active: active || isParent,
                    'font-weight-500': category.level === 0,
                })}
                onClick={() => {
                    !isOpen && handleSelectCategory(category._id)
                }}
            >
                <span>{category.name}</span>
                {category.slug === 'preview-3d-model' && (
                    <Badge color="danger" className="ml-2">
                        New
                    </Badge>
                )}
            </NavLink>
        </NavItem>
    )
}

const RecursiveItem = ({selectedCategory, category, categoryChildren, handleSelectCategory, index}) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleCollapse = () => {
        setIsOpen(!isOpen)
    }

    if (!category || (category && category.level > 1)) return null

    if (!category.children) {
        return (
            <div className="CategoryItem">
                <CategoryItem
                    index={index}
                    isOpen={isOpen}
                    category={category}
                    selectedCategory={selectedCategory}
                    handleSelectCategory={handleSelectCategory}
                />
            </div>
        )
    }

    return (
        <Fragment>
            <div
                className={classnames('CategoryItem d-flex align-items-center justify-content-between pr-3', {
                    IsOpen: isOpen,
                })}
                onClick={toggleCollapse}
            >
                <CategoryItem
                    index={index}
                    category={category}
                    categoryChildren={categoryChildren}
                    selectedCategory={selectedCategory}
                    handleSelectCategory={handleSelectCategory}
                />
                {!!category.children && category.level < 1 && (
                    <div className="BtnArrow">
                        <i className={`fa ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'} cursor-pointer`} />
                    </div>
                )}
            </div>
            <Collapse isOpen={isOpen} className='pl-4'>
                {category.children &&
                    category.children.map((item, index) => (
                        <RecursiveItem
                            index={index}
                            selectedCategory={selectedCategory}
                            category={item}
                            categoryChildren={categoryChildren}
                            level={category + 1}
                            handleSelectCategory={handleSelectCategory}
                        />
                    ))}
            </Collapse>
        </Fragment>
    )
}

MockupGeneratorNavTab.propTypes = {
    activeTab: PropTypes.string.isRequired,
    onHandleTabs: PropTypes.func.isRequired,
}

export default MockupGeneratorNavTab

